export const DB32 = [
    '  0,   0,   0',
    ' 34,  32,  52',
    ' 69,  40,  60',
    '102,  57,  49',
    '143,  86,  59',
    '223, 113,  38',
    '217, 160, 102',
    '238, 195, 154',
    '251, 242,  54',
    '153, 229,  80',
    '106, 190,  48',
    ' 55, 148, 110',
    ' 75, 105,  47',
    ' 82,  75,  36',
    ' 50,  60,  57',
    ' 63,  63, 116',
    ' 48,  96, 130',
    ' 91, 110, 225',
    ' 99, 155, 255',
    ' 95, 205, 228',
    '203, 219, 252',
    '255, 255, 255',
    '155, 173, 183',
    '132, 126, 135',
    '105, 106, 106',
    ' 89,  86,  82',
    '118,  66, 138',
    '172,  50,  50',
    '217,  87,  99',
    '215, 123, 186',
    '143, 151,  74',
    '138, 111,  48'
]

export const NES = [
    '  0,   0,   0',
    '  0,   0,   0',
    '121, 121, 121',
    '162, 162, 162',
    ' 48,  81, 130',
    ' 65, 146, 195',
    ' 97, 211, 227',
    '162, 255, 243',
    ' 48,  97,  65',
    ' 73, 162, 105',
    '113, 227, 146',
    '162, 255, 203',
    ' 56, 109,   0',
    ' 73, 170,  16',
    '113, 243,  65',
    '162, 243, 162',
    ' 56, 105,   0',
    ' 81, 162,   0',
    '154, 235,   0',
    '203, 243, 130',
    ' 73,  89,   0',
    '138, 138,   0',
    '235, 211,  32',
    '255, 243, 146',
    '121,  65,   0',
    '195, 113,   0',
    '255, 162,   0',
    '255, 219, 162',
    '162,  48,   0',
    '227,  81,   0',
    '255, 121,  48',
    '255, 203, 186',
    '178,  16,  48',
    '219,  65,  97',
    '255,  97, 178',
    '255, 186, 235',
    '154,  32, 121',
    '219,  65, 195',
    '243,  97, 255',
    '227, 178, 255',
    ' 97,  16, 162',
    '146,  65, 243',
    '162, 113, 255',
    '195, 178, 255',
    ' 40,   0, 186',
    ' 65,  65, 255',
    ' 81, 130, 255',
    '162, 186, 255',
    ' 32,   0, 178',
    ' 65,  97, 251',
    ' 97, 162, 255',
    '146, 211, 255',
    '121, 121, 121',
    '178, 178, 178',
    '235, 235, 235',
    '255, 255, 255'
]

export const EDG16 = [
    '  0,   0,   0',
    '228, 166, 114',
    '184, 111,  80',
    '116,  63,  57',
    ' 63,  40,  50',
    '158,  40,  53',
    '229,  59,  68',
    '251, 146,  43',
    '255, 231,  98',
    ' 99, 198,  77',
    ' 50, 115,  69',
    ' 25,  61,  63',
    ' 79, 103, 129',
    '175, 191, 210',
    '255, 255, 255',
    ' 44, 232, 244',
    '  4, 132, 209',
    'ERASER'
]
